import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgModule } from '@angular/core';
import { AddProductsDialogComponent } from './addProductsDialog.component';
import { AddUserDialogComponent } from './addUserDialog.component';
import { CreateSiteComponent } from './createSite.component';
import { SiteDetailsComponent } from './siteDetails.component';
import { SitesComponent } from './sites.component';
import { SitesListComponent } from './sitesList.component';
import { PartnerComponent } from './partner.component';
import { ProductCatalogsComponent } from './productCatalogs.component';
import { TenantEditorComponent } from './tenantEditor.component';
import { TenantSummaryComponent } from './tenantSummary.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    declarations: [
        AddProductsDialogComponent,
        AddUserDialogComponent,
        CreateSiteComponent,
        SiteDetailsComponent,
        SitesComponent,
        SitesListComponent,
        PartnerComponent,
        ProductCatalogsComponent,
        TenantEditorComponent,
        TenantSummaryComponent
    ],
    exports: [
        PartnerComponent
    ],
    entryComponents: [
        AddProductsDialogComponent,
        AddUserDialogComponent
    ]
})
export class PartnerModule {
}